import type { RouteLocationRaw } from 'vue-router';

export function isUnassociatedPayment(payment: {
  booking?: { id?: string } | null;
  invoice?: { id?: string } | null;
}): boolean {
  return !payment.booking?.id && !payment.invoice?.id;
}

/** Euros of this payment sitting on the booking, when the payment is not filed on it. */
export function getBookingShareAmount(
  payment: {
    booking?: { id?: string } | null;
    allocatedBookings?: Array<{ id: string; attributedAmount: number }>;
  },
  bookingId?: string,
): number | undefined {
  if (!bookingId || payment.booking?.id === bookingId) return undefined;
  return payment.allocatedBookings?.find((row) => row.id === bookingId)?.attributedAmount;
}

/**
 * Where a payment shown on a booking should open when it is not that booking's payment.
 * Unassociated payments (no booking, no invoice) open on their own page.
 */
export function getBookingPaymentDestination(
  payment: {
    id: string;
    booking?: { id?: string } | null;
    invoice?: { id?: string } | null;
  },
  bookingId?: string,
  options?: { canOpenPayment?: boolean },
): RouteLocationRaw | undefined {
  if (!bookingId || payment.booking?.id === bookingId) return undefined;
  if (payment.booking?.id) {
    return {
      name: 'bookingEdit',
      params: { id: payment.booking.id },
      query: { paymentId: payment.id },
    };
  }
  if (payment.invoice?.id) {
    return {
      name: 'invoice',
      params: { id: payment.invoice.id },
      query: { paymentId: payment.id },
    };
  }
  if (options?.canOpenPayment === false) return undefined;
  return { name: 'payment', params: { id: payment.id } };
}
